export const barcodeFormat = (barcode: string) => {
    const resultString = barcode.replace(/(\d{4})(?=\d)/g, '$1-');
    return resultString;
};
